import { useCallback } from 'react'
import type { PaymentLink } from '@shared/types/payment-links'
import { toast } from 'sonner'

const CHECKOUT_URL = import.meta.env.VITE_CHECKOUT_URL || 'http://localhost:5173'

export function usePaymentLinkActions(handleOpenEdit?: (paymentLink: PaymentLink) => void) {
  const handleCopyLinkUrl = useCallback((link: PaymentLink) => {
    if (!link.shortCode) {
      return
    }
    const url = `${CHECKOUT_URL}/pay/${link.shortCode}`
    navigator.clipboard.writeText(url).then(() => {
      toast.success('Link copied to clipboard')
    }).catch(() => {
      toast.error('Failed to copy link')
    })
  }, [])

  const handlePreviewLink = useCallback((link: PaymentLink) => {
    if (!link.shortCode) {
      return
    }
    window.open(`${CHECKOUT_URL}/pay/${link.shortCode}`, '_blank')
  }, [])

  const handleUpdate = useCallback((link: PaymentLink) => {
    if (handleOpenEdit) {
      handleOpenEdit(link)
    }
  }, [handleOpenEdit])

  const handleDeactivate = useCallback((_link: PaymentLink) => {
    toast.info('Deactivation is not yet implemented')
  }, [])

  const handleBatchActivate = useCallback((_ids: string[]) => {
    toast.info('Batch activation is not yet implemented')
  }, [])

  const handleBatchDeactivate = useCallback((_ids: string[]) => {
    toast.info('Batch deactivation is not yet implemented')
  }, [])

  const handleBatchExport = useCallback((_ids: string[]) => {
    toast.info('Batch export is not yet implemented')
  }, [])

  return {
    handleCopyLinkUrl,
    handlePreviewLink,
    handleUpdate,
    handleDeactivate,
    handleBatchActivate,
    handleBatchDeactivate,
    handleBatchExport
  }
}
